module.exports = __webpack_public_path__ + "img/classes.8c7a147e.svg";